// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"22f7263a","312":"87b44cfd","556":"b50df953","746":"17f286ce","779":"0d733ec2"}[chunkId] + ".chunk.css";
};